import React, { Component } from "react";
import { ApolloProvider } from "react-apollo";
import PropTypes from "prop-types";
import { ThemeProvider } from "@zendeskgarden/react-theming";
import t from "@zendesk/client-i18n-tools";
import NewRoute from "components/NewRoute";
import IndexRoute from "components/IndexRoute";
import EditRoute from "components/EditRoute";
import apolloClient from "../../apollo/client";
import { Notifications } from "@zendesk/knowledge-components/lib/Notifications/Connected";

export class App extends Component {
  static propTypes = {
    route: PropTypes.oneOf(["index", "new", "edit", "duplicate"]).isRequired,
    params: PropTypes.object.isRequired,
  };

  renderRoute(route) {
    const { params } = this.props;
    switch (route) {
      case "new":
        return <NewRoute />;
      case "edit":
      case "duplicate":
        return <EditRoute id={params.id} isDuplicate={params.isDuplicate} />;
      default:
        return <IndexRoute />;
    }
  }

  render() {
    const { route } = this.props;
    return (
      <ThemeProvider rtl={t.dir === "rtl"}>
        <ApolloProvider client={apolloClient}>
          {this.renderRoute(route)}
          <Notifications />
        </ApolloProvider>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.js